export const ContactForm = {
  Contact: 'contact',
};

export const ContactFormOptions = [{ key: ContactForm.Contact, value: ContactForm.Contact, text: 'Contact us!' }];
